import { ErrorMessage } from '@com-delta-idp/mnx-capability-flyout-ui';
import { AEMErrorMessage } from '../../../../../models/utils/error-message.interface';

export const getErrorMessage = (
  component: string,
  aemErrorMessages: AEMErrorMessage[] | undefined
): ErrorMessage | undefined => {
  const errorMessage =
    aemErrorMessages &&
    aemErrorMessages.find((item) => {
      return item.component === component;
    });
  if (errorMessage) {
    return {
      action: {
        label: errorMessage.action.label,
        url: errorMessage.action.url,
        id: errorMessage.action.id
      },
      title: errorMessage.featureTitle,
      disable: false,
      message: {
        title:
          errorMessage.type === 'single-error'
            ? errorMessage.errorMessageDescription
            : errorMessage.errorMessageTitle,
        subtitle: errorMessage.errorMessageDescription
      },
      type: errorMessage.type, // This is used to specify full page or single error
      icon: getIcon(errorMessage),
      ariaLabel: getAriaLabel(errorMessage)
    };
  } else {
    return undefined;
  }
};

export const getIcon = (errorMessage: AEMErrorMessage) => {
  return errorMessage.icon
    ? errorMessage.icon.src
    : '/content/dam/delta-applications/ui-kit/assets/svg/alerts/alert-red-invert.svg';
};

export const getAriaLabel = (errorMessage: AEMErrorMessage) => {
  return {
    icon: errorMessage.icon ? errorMessage.icon.alt : 'alert'
  };
};
